import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { CopyBlock, dracula } from "react-code-blocks";
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";

const ReactLesson2 = () => {

    const [language, changeLanguage] = useState("react");
    const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `




      `




    );



  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <div className="alert alert-secondary" role="alert">
    <h3><strong>What is React</strong></h3>
      <p>React is a popular front-end library developed by Facebook that allows developers to create reusable UI components. It enables the creation of complex and responsive web applications with ease. React's component-based architecture, along with its efficient rendering methods, makes it a go-to choice for building modern web applications.</p>
    </div>
    <div className="alert alert-secondary" role="alert">
      <h3><strong>History of React</strong></h3>
      <p>React was developed by <strong>Jordan Walke</strong>, a software engineer at Facebook. It was first deployed on Facebook's newsfeed in 2011 and later on Instagram in 2012. React was officially released to the public as an open-source project in May 2013.</p>
      <p>Here's a historical timeline highlighting the key milestones and developments in the history of React:</p>
      <h4>2011:</h4>
      <ol>
          <li><strong>Internal Development:</strong> Jordan Walke at Facebook starts developing a JavaScript library called React to address the challenges of updating the user interface in large web applications.</li>
      </ol>
      <h4>2012:</h4>
      <ol>
          <li><strong>Deployment on Facebook:</strong> React is first deployed on Facebook's newsfeed, enabling faster rendering and better performance for handling complex UI updates.</li>
          <li><strong>Integration with Instagram:</strong> React is introduced to Instagram's web interface, proving its capabilities in diverse environments.</li>
      </ol>
      <h4>2013:</h4>
      <ol>
          <li><strong>Open Sourcing:</strong> React is officially open-sourced by Facebook at the JSConf US event in May 2013. The library becomes available for developers outside of Facebook to use and contribute to.</li>
          <li><strong>Introduction of Virtual DOM:</strong> React's innovative Virtual DOM implementation becomes a standout feature, improving performance by efficiently updating the DOM based on changes in data.</li>
      </ol>
      <h4>2014:</h4>
      <ol>
          <li><strong>Introduction of React Native:</strong> React Native, a framework for building native mobile applications using React, is announced at the React.js Conf in January 2015. It allows developers to write mobile apps using JavaScript and React while delivering a native user experience.</li>
      </ol>
      <h4>2015:</h4>
      <ol>
          <li><strong>Release of React 0.14:</strong> Facebook introduces React 0.14, which brings improvements and enhancements to the library's core features, along with the deprecation of some older methods.</li>
      </ol>
      <h4>2016:</h4>
      <ol>
          <li><strong>Introduction of React Fiber:</strong> Facebook announces React Fiber, a reimplementation of the React core algorithm, designed to improve performance, concurrency, and the ability to handle larger applications more efficiently.</li>
      </ol>
      <h4>2017:</h4>
      <ol>
          <li><strong>React 16 (React Fiber) Release:</strong> React 16, based on React Fiber, is released. It introduces features like error boundaries, improved server-side rendering, and the Context API.</li>
      </ol>
      <h4>2018:</h4>
      <ol>
          <li><strong>React 16.3:</strong> React 16.3 introduces new Context API, better support for asynchronous rendering, and an official React DevTools extension.</li>
          <li><strong>Suspense and Concurrent Mode:</strong> Facebook starts talking about experimental features like Suspense and Concurrent Mode, aiming to enhance the user experience with more asynchronous rendering capabilities.</li>
      </ol>
      <h4>2020 and Beyond</h4>
      <ol>
          <li><strong>Continued Updates:</strong> React continues to evolve, introducing new features, optimizations, and enhancements regularly. The React team focuses on improving performance, developer experience, and expanding capabilities while maintaining backward compatibility.</li>
      </ol>
      </div>
      <div className="alert alert-secondary" role="alert">
      <h3><strong>Purpose of React</strong></h3>
        <p>React was created with several primary purposes in mind, aiming to address various challenges in building user interfaces for web and mobile applications. Some of the core purposes and advantages of using React include:</p>
        <ol class="list-group list-group-numbered mb-4">
            <li><strong>Component-Based Architecture:</strong></li>
            <ul>
                <li><strong>Modularity:</strong> React encourages a component-based architecture, breaking down the UI into reusable and independent components. This modular approach simplifies development, improves code organization, and enhances reusability.</li>
            </ul>
            <li><strong>Declarative and Reactive:</strong></li>
            <ul>
                <li><strong>Declarative Syntax:</strong> React uses a declarative programming paradigm, allowing developers to describe the desired UI state and React takes care of efficiently rendering the components based on state changes.</li>
                <li><strong>Reactivity:</strong> React employs a reactive and efficient Virtual DOM mechanism, updating only the necessary parts of the DOM when the data changes. This results in better performance by minimizing unnecessary re-renders.</li>
            </ul>
            <li><strong>Virtual DOM:</strong></li>
            <ul>
                <li><strong>Efficient Rendering:</strong> React utilizes a Virtual DOM to optimize rendering by maintaining an in-memory representation of the actual DOM. When data changes, React updates the Virtual DOM first and then applies the minimal necessary changes to the real DOM, reducing performance bottlenecks.</li>
            </ul>
            <li><strong>Reusable and Composable Components:</strong></li>
            <ul>
                <li><strong>Component Reusability:</strong> React components are highly reusable, enabling developers to create complex UIs by combining and reusing smaller components. This reusability streamlines development, encourages maintainability, and fosters a consistent design language.</li>
            </ul>
            <li><strong>React Native for Mobile Development:</strong></li>
            <ul>
                <li><strong>Cross-Platform Development:</strong> React Native extends the power of React to mobile platforms, allowing developers to build native mobile applications using JavaScript and React. It enables code sharing across iOS and Android, reducing development time and effort.</li>
            </ul>
            <li><strong>Developer Efficiency and Ecosystem:</strong></li>
            <ul>
                <li><strong>Ecosystem and Tooling:</strong> React has a rich ecosystem of libraries, tools, and community support. It offers a wide range of developer tools (such as React DevTools) and integrates well with other libraries, making it easier for developers to create, test, and maintain applications.</li>
            </ul>
            <li><strong>SEO-Friendly and Performance:</strong></li>
            <ul>
                <li><strong>SEO Support:</strong> React is SEO-friendly, enabling better server-side rendering capabilities that improve search engine indexing for web applications.</li>
                <li><strong>Performance Optimizations:</strong> React's efficient rendering and state management contribute to better performance in applications, particularly in handling complex and data-intensive user interfaces.</li>
            </ul>
            <li><strong>Continuous Development and Improvement:</strong></li>
            <ul>
                <li><strong>Active Development:</strong> React is actively developed and maintained by Facebook and a large community of contributors. Regular updates introduce new features, enhancements, and optimizations, ensuring React stays relevant and up-to-date with evolving web development trends.</li>
            </ul>
             </ol>
             <p>React's primary purpose is to provide developers with a powerful, efficient, and flexible toolset for building dynamic and performant user interfaces, whether for web or mobile applications, while promoting code reusability, maintainability, and developer productivity.</p>
                <br/>

                </div>
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson2
